export const pageContentInitialState = {
    data: {},
    isFetching: false,
    hasFetchingError: false,
    initialState: true,
    isSubmitting: false,
    isSubmitted: false,
    hasSubmissionError: false,
    error: ''
};


export const pageContentReducer = (state, action) => {
    switch (action.type) {
        case "FETCH_REQUEST":
            return {
                ...state,
                hasFetchingError: false,
                isFetching: true,
            };
        case "FETCH_SUCCESS":
            return {
                data: action.payload,
                hasFetchingError: false,
                isFetching: false,
            };
        case "FETCH_FAILURE":
            return {
                ...state,
                hasFetchingError: true,
                isFetching: false,
                error: action.payload
            };

        case "FORM_SUBMISSION_REQUEST":
            return {
                ...state,
                isSubmitting: true,
                hasSubmissionError: false,
            };
        case "FORM_SUBMISSION_SUCCESS":
            return {
                ...state,
                isSubmitting: false,
                isSubmitted: true,
            };
        case "FORM_SUBMISSION_FAILURE":
            return {
                ...state,
                isSubmitting: false,
                hasSubmissionError: true,
                error: action.payload
            };
        case "FORM_INITIAL_STATE":
            return {
                ...state,
                initialState: true,
                isSubmitting: false,
                isSubmitted: false,
                hasSubmissionError: false,
                error: ''
            };

        default:
            return state;
    }
}